const VERSIONS = {
  colombia: 'V6441-3.0.4',
}

export {VERSIONS}
